<script lang="ts">
  import RetailerUserAuthentication from "@retailer/svelte/ProductLines/OrderActionBar/Cards/RetailerUserAuthentication.svelte";

  // export let mobileMode: boolean;
  export let authService: any;
</script>

<div class="craft" data-testid="vermont-action-bar-cta">
  <RetailerUserAuthentication {authService}>
    <div slot="pending-title">Access High Proof Spirits & Liquor!</div>
    <div slot="pending-buttons">
      <a
        on:click|preventDefault={() => authService?.startVerification?.("pending")}
        class="fizz-link fizz-text-strong fizz-text-small">Verify Account</a
      >
    </div>
  </RetailerUserAuthentication>
</div>
